'use strict';
define([
    'angular',
    'modules/keywordtracker/report/report.controller'
], function (angular, KeywordTrackerReportCtrl) {
    var app = angular.module('app.keywordtracker.report', []);
    app.controller('KeywordTrackerReportCtrl', KeywordTrackerReportCtrl);
    return app;
});
